@import '../../app-brand/entities/entity-layer.module.less';

.locked-address {
  color: @order-drawer--lock-address--text-color;
  display: flex;
  height: 10px;
  font-size: 12px;
  .text-warning {
    align-items: center;
    margin-left: -5px;
    display: flex;
  }
  .lock-icon {
    fill: @order-drawer--lock-address--fill-color;
  }
  .locked-address-link {
    margin-left: 12px;
    align-self: center;
    font-size: 12px;
  }
}
